export default "__VITE_ASSET__BB9YbHj8__"